import type { LauraP0QuestionCategory } from "@/app/components/shared/types";
import type { TranslationDictionary } from "@/app/i18n/types";

type LauraT = <K extends keyof TranslationDictionary["laura"]>(
    ns: "laura",
    key: K,
    vars?: Record<string, string | number>,
) => string;

export function p0CategoryLabel(category: LauraP0QuestionCategory, t: LauraT): string {
    switch (category) {
        case "objeto":
            return t("laura", "p0CategoryObjeto");
        case "escopo":
            return t("laura", "p0CategoryEscopo");
        case "problema":
            return t("laura", "p0CategoryProblema");
        case "recursos":
            return t("laura", "p0CategoryRecursos");
        default:
            return t("laura", "p0CategoryComplementar");
    }
}
